/**
 * A MÁQUINA DE ESTADO DO RAMAL, pura.
 *
 * Pura porque é aqui que mora o que quebra na vida real: credencial que vence
 * no meio da conversa, rede que cai com chamada em curso, dois "atender" pelo
 * clique nervoso. Nada disso se testa com navegador aberto e telefone tocando;
 * se testa aqui, com relógio na mão.
 *
 * Quem fala SIP é o adaptador. Esta parte só decide.
 */
export const situacaoInicial = {
    registro: "desligado", chamada: "ociosa", mudo: false,
    credencialExpiraEm: null, aviso: null,
};
/**
 * A transição.
 *
 * Duas regras que parecem detalhe e não são:
 *
 * 1. **Perder o registro NÃO derruba a conversa em curso.** O registro serve
 *    para RECEBER chamada; a que já está de pé tem caminho de mídia próprio.
 *    Encerrar a ligação porque o registro caiu desligaria na cara do cliente
 *    por um soluço de rede.
 * 2. **Encerrar é idempotente.** O clique nervoso, o botão da tela e o evento
 *    da central chegam os três, e nenhum pode reabrir estado.
 */
export function aplicar(s, e) {
    switch (e.tipo) {
        case "credencial_recebida":
            return { ...s, credencialExpiraEm: e.expiraEm, registro: s.registro === "desligado" ? "registrando" : s.registro };
        case "registrou":
            return { ...s, registro: "registrado", aviso: null };
        case "registro_caiu":
            // A conversa em curso continua. Só o registro cai.
            return { ...s, registro: "sem_registro", aviso: e.motivo ?? "O ramal perdeu a conexão. Tentando de novo." };
        case "discou":
            return s.chamada === "ociosa" ? { ...s, chamada: "discando", aviso: null } : s;
        case "tocando":
            return s.chamada === "discando" || s.chamada === "ociosa" ? { ...s, chamada: "tocando" } : s;
        case "atendida":
            return s.chamada === "encerrando" ? s : { ...s, chamada: "em_conversa", aviso: null };
        case "em_espera":
            if (s.chamada !== "em_conversa" && s.chamada !== "em_espera")
                return s;
            return { ...s, chamada: e.ligado ? "em_espera" : "em_conversa" };
        case "mudo":
            return { ...s, mudo: e.ligado };
        case "encerrando":
            return s.chamada === "ociosa" ? s : { ...s, chamada: "encerrando" };
        case "encerrou":
            return { ...s, chamada: "ociosa", mudo: false, aviso: e.motivo ?? s.aviso };
        case "sem_microfone":
            return {
                ...s, chamada: "ociosa",
                aviso: "O navegador não liberou o microfone. Autorize no cadeado da barra de endereço e tente de novo.",
            };
        case "desligar":
            return { ...situacaoInicial };
        default:
            return s;
    }
}
/** Está em chamada, de qualquer forma? A tela usa para travar botão. */
export const emChamada = (s) => s.chamada !== "ociosa";
/**
 * Está na hora de renovar a credencial?
 *
 * Renova com folga, e a folga não é enfeite: renovar no instante do vencimento
 * é renovar tarde, porque a ida e volta até o servidor demora. Um minuto antes
 * é o suficiente para a rede ruim de uma agência.
 */
export function precisaRenovar(s, agora = new Date(), folgaMs = 60_000) {
    if (!s.credencialExpiraEm)
        return true;
    return s.credencialExpiraEm.getTime() - agora.getTime() <= folgaMs;
}
/**
 * Pode desligar o ramal agora?
 *
 * Não durante conversa. Trocar de agência ou fechar a aba com uma ligação de
 * pé é o caminho mais curto para derrubar o cliente sem querer.
 */
export const podeDesligar = (s) => s.chamada === "ociosa";
//# sourceMappingURL=maquina.js.map